import { render, staticRenderFns } from "./legal-entity-not-linked-error.vue?vue&type=template&id=5776e7fb&scoped=true&"
import script from "./legal-entity-not-linked-error.vue?vue&type=script&lang=js&"
export * from "./legal-entity-not-linked-error.vue?vue&type=script&lang=js&"
import style0 from "./legal-entity-not-linked-error.vue?vue&type=style&index=0&id=5776e7fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776e7fb",
  null
  
)

export default component.exports